<template>
    <div class="container-fluid">
        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mt-3 mb-n3">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <!-- General -->
        <div class="row my-5">
            <div class="col-12 pl-0">
                <form>
                    <h5>Change shop passcode</h5>
                    <p class="mt-4 mb-2">
                        To ensure your shop is protected, we will send you an email with a link to reset your passcode, click the button below.
                    </p>
                    <button @click.prevent="forgotPasscodeFxn" class="loadn btn btn-dark-green mt-4">Send Passcode Reset Link</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: "Passcode",
    data() {
        return {
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['forgotPasscode', 'createTransaction']),
        forgotPasscodeFxn() {
            let userObj = {
                userId: this.user._id,
                email: this.user.email
            }
            this.forgotPasscode(userObj)
            .then((data) => {
                if(!data.error) {
                    this.color = "success"
                    let eventObj = {
                        userId: this.user._id,
                        event: "requested shop-passcode reset link"
                    }
                    this.createTransaction(eventObj)
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.msg = "sorry, we are unable to process your request this time. Try again!"
            })
        }
    },
    computed: {
        ...mapGetters(['user']),
    },
}
</script>